export default "__VITE_ASSET__dba6228a__"